module.exports = require('./helpers/bundle-url').getBundleURL('8g68e') + "ote-texture-bg.39d7f4d1.jpg";